<template>
  <validator name="newDelayedValidator">
    <form novalidate>
      <div class="mdl-grid mdl-grid--nesting">
        <div class="mdl-cell mdl-cell--6-col">
          <div class="mdl-card fill mdl-shadow--2dp">
            <div class="ga-form-title">
              <h2 class="ga-title-text">{{'newDelayed.label.options' | label}}</h2>
            </div>
            <div class="mdl-card__supporting-text">
              <!--<div class="mdl-grid inner-grid">-->
                <div class="mdl-grid inner-grid">
                  <label class="delivery-label form-label ga-required">{{'newDelayed.label.initialSending' | label}}</label>
                </div>
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill dirty-check">
                  <datepicker :time.sync="initDate" :out.sync="message['initialDelayMessageDate']" type="min" format="LLLL" :limit="limit">
                    <input v-show="false" class="mdl-textfield__input" type="text" id="initialDelayMessageDate" initial="off"
                           v-model="message['initialDelayMessageDate']" v-validate:initialDelayMessageDate="['required']">
                    <span class="validation-error mdl-textfield__error" v-if="$newDelayedValidator.initialdelaymessagedate.required">{{'newDelayed.validation.initialSending' | label}}</span>
                    <span class="ga-input-instruction" v-if="!$newDelayedValidator.initialdelaymessagedate.required">{{'newDelayed.instruction.initialDelayMessageDate' | label}}</span>
                  </datepicker>
                </div>
              <!--</div>-->
              <div class="mdl-grid inner-grid">
                <div class="mdl-cell mdl-cell--8-col">
                  <label class="form-label ga-required">{{'newDelayed.label.sendCancellationEvery' | label}}</label>
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                  <mdl-select name='delay_period' :value.sync="message['delayMessagePeriod']" options="SENDING_PERIOD"
                              :preselected="getDelayMessagePeriod()"></mdl-select>
                </div>
                <span class="ga-input-instruction">{{'newDelayed.instruction.delayMessagePeriod' | label}}</span>
              </div>
              <!--<div class="mdl-grid inner-grid">-->
                <!--<div class="mdl-cell mdl-cell&#45;&#45;8-col">-->
                  <!--<label class="form-label">{{'newDelayed.label.confirmBy' | label}}</label>-->
                <!--</div>-->
                <!--<div class="mdl-cell mdl-cell&#45;&#45;4-col">-->
                  <!--<mdl-select name='delay_method' :value.sync="message['delayMethod']" options="CONFIRMATION_TYPE"-->
                              <!--preselected="MAIL"></mdl-select>-->
                <!--</div>-->
                <!--<span class="ga-input-instruction">{{'newDelayed.instruction.delayMethod' | label}}</span>-->
              <!--</div>-->
              <div class="mdl-grid inner-grid">
                <div class="mdl-cell mdl-cell--8-col">
                  <label class="form-label ga-required">{{'newDelayed.label.sendAfter' | label}}</label>
                  <span class="validation-error mdl-textfield__error"
                  v-if="$newDelayedValidator.sendafter.required">{{'newDelayed.validation.sendAfter' | label}}</span>
                  <span class="validation-error mdl-textfield__error"
                  v-if="$newDelayedValidator.sendafter.max">{{'newDelayed.validation.sendAfter.maxDays' | label}}</span>
                    </div>
                <div class="mdl-cell mdl-cell--2-col">
                  <div class="mdl-textfield mdl-js-textfield inline">
                    <input class="mdl-textfield__input" type="number" min="1" max="{{getAppConfig('maxSendAfterDays')}}" id="sendAfter" initial="off"
                    v-validate:sendAfter="{required: true, max: getAppConfig('maxSendAfterDays')}" v-model="message['sendMessageAfter']">
                    <label class="mdl-textfield__label ga-required" for="sendAfter"></label>
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--2-col">
                  <label class="form-label">{{'newDelayed.label.days' | label}}</label>
                </div>
                <span class="ga-input-instruction" v-if="!$newDelayedValidator.sendafter.max">{{'newDelayed.instruction.sendAfter' | label}}</span>
              </div>
              <div class="mdl-grid inner-grid">
                <div class="mdl-cell mdl-cell--12-col">
                  <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label dirty-check fill">
                    <div class="iconized">
                      <input class="mdl-textfield__input" :type="faEye1.inputType" id="additionalDelayEmail"
                            v-model="message['additionalDelayEmail']" v-validate:additionalDelayEmail="['email']">
                      <span class="fas" :class="faEye1.class" @click="toggleEye1">&nbsp;</span>
                    </div>
                    <label class="mdl-textfield__label" for="additionalDelayEmail">{{'newDelayed.label.additionalEmail' | label}}</label>
                    <span class="validation-error mdl-textfield__error"
                          v-if="$newDelayedValidator.additionaldelayemail.email">{{'newDelayed.validation.additionalEmail.email' | label}}</span>
                    <span class="ga-input-instruction" v-if="!$newDelayedValidator.additionaldelayemail.email">{{'newDelayed.instruction.additionalDelayEmail' | label}}</span>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="mdl-cell mdl-cell--6-col">
        <div class="mdl-card fill mdl-shadow--2dp">
          <div class="ga-form-title">
            <h2 class="ga-title-text">{{'newDelayed.label.title' | label}}</h2>
          </div>
          <div class="mdl-card__supporting-text fill">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill dirty-check">
              <div class="iconized">
                <input class="mdl-textfield__input" :type="faEye2.inputType" id="recipients" initial="off"
                v-validate:recipients="['emailArray']"  v-model="message['message']['recipients']">
                <span class="fas" :class="faEye2.class" @click="toggleEye2">&nbsp;</span>
              </div>
              <label class="mdl-textfield__label ga-required" for="recipients">{{'newDelayed.label.recipients' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$newDelayedValidator.recipients.emailArray">{{'newDelayed.validation.recipients' | label}}</span>
              <span class="ga-input-instruction" v-if="!$newDelayedValidator.recipients.emailArray">{{'newDelayed.instruction.recipients' | label}}</span>
            </div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label fill dirty-check">
              <input class="mdl-textfield__input" type="text" id="subject" initial="off"
                     v-validate:subject="['required']" v-model="message['message']['subject']">
              <label class="mdl-textfield__label ga-required" for="subject">{{'newDelayed.label.subject' | label}}</label>
              <span class="validation-error mdl-textfield__error" v-if="$newDelayedValidator.subject.required">{{'general.validation.required' | label}}</span>
              <span class="ga-input-instruction" v-if="!$newDelayedValidator.subject.required">{{'newDelayed.instruction.subject' | label}}</span>
            </div>
            <!--<div class="mdl-textfield mdl-js-textfield mdl-textfield&#45;&#45;floating-label fill">-->
            <text-area :body.sync="message['message']['messageBody']" :placeholder="getLabel('newDelayed.label.messageBody')" component-id="newdelayed">
            </text-area>
            <input v-show="false" class="mdl-textfield__input" type="text" id="messageBody" initial="off" v-model="message['message']['messageBody']" v-validate:messageBody="['required']">
            <span class="validation-error mdl-textfield__error" v-if="$newDelayedValidator.messagebody.required">{{'newDelayed.validation.messageBody' | label}}</span>
            <span class="ga-input-instruction" v-if="!$newDelayedValidator.messagebody.required">{{'newDelayed.instruction.messageBody' | label}}</span>
            <!--</div>-->
            <div class="mdl-grid inner-grid">
              <div class="mdl-cell mdl-cell--6-col">
                <div v-el:attachment class="attachment-label form-label">{{'newDelayed.label.attachments' | label}}
                </div>
              </div>
              <div class="mdl-cell mdl-cell--6-col">
                <div v-el:addAttachment v-on:click="addAttachment()"
                  class="mdl-button mdl-js-button mdl-button--fab mdl-button--mini-fab" value="">
                  <i class="material-icons">add</i>
                </div>
                  <input class="display-none" v-el:file type="file" v-on:change="uploadFile()" multiple/>
              </div>
              <span class="ga-input-instruction">{{'newDelayed.instruction.attachments' | label}}</span>
            </div>
            <div class="mdl-grid inner-grid">
              <div class="mdl-cell mdl-cell--12-col">
                <attachment v-for="(attachment, index) in message['message']['attachments']" :file.sync=attachment :attachments.sync=message['message']['attachments'] v-bind:key="index"></attachment>
              </div>
            </div>
            <div v-if="message.status!=='SENT'" class="mdl-card__actions">
              <div class="card-grid mdl-grid">
                <div class="mdl-cell mdl-cell--4-col">
                  <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill" v-if="registration"
                       v-on:click="backToReg()">
                      {{'newDelayed.button.back' | label}}
                  </div>
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                </div>
                <div class="mdl-cell mdl-cell--4-col">
                  <div v-el:saveButton class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored fill"
                       v-on:click="validate()">
                  <span v-if="registration">
                    {{'newDelayed.button.next' | label}}
                  </span>
                    <span v-if="!registration">
                    {{'newDelayed.button.save' | label}}
                  </span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      </div>
    </form>
  </validator>
</template>

<script>
  var file = require('api/File')
//  var config = require('common/config')
  var getters = require('common/store/getters')
  var label = require('vue').filter('label')
  var appConfig = require('vue').filter('appConfig')
  module.exports = {
    ready: function () {
      window.componentHandler.upgradeAllRegistered()
    },
    vuex: {
      getters: getters
    },
    props: {
      model: Object,
      registration: Boolean,
      initDate: ''
    },
    components: {
      'datepicker': require('c/components/Datepicker'),
      'attachment': require('c/components/Attachment'),
      'text-area': require('c/components/TextArea'),
      mdlSelect: require('c/components/Select')
    },
    methods: {
      validate: function () {
        var self = this
        if (self.uploading) {
          return
        }
        this.$validate(true, function () {
          if (self.$newDelayedValidator.invalid) {
            return
          }
//          self.message.phone = self.message.phoneCode + self.message.phoneNumber
          self.$dispatch('message-valid', self.message)
        })
      },
      uploadFile: function () {
        var self = this
        var files = this.$els.file.files
        var fileTypes = appConfig('fileTypes')
        // var maxMessageSize = appConfig('maxMessageSize')
        var maxFileSize = appConfig('maxFileSize')
        Object.keys(files).forEach(function (i) {
          if (fileTypes.indexOf(files[i].type) === -1) {
            self.$dispatch('show-error', new Error(label('general.file.error.unsupported')))
            return
          }
          if (files[i].size > maxFileSize) {
            self.$dispatch('show-error', new Error(label('newScheduled.validation.attachments.maxFileSize')))
            return
          }
          // not needed anymore: any attachment becomes a link
          // if (self.totalAttachmentSize + files[i].size > maxMessageSize) {
          //   self.$dispatch('show-error', new Error(label('newScheduled.validation.attachments.maxSize')))
          //   return
          // }
          var f = files[i]
          var attachment = {
            'fileName': f.name,
            'fileSize': f.size,
            'contentType': f.type
          }
          self.message.message.attachments.push(attachment)
          self.uploading = true
          file.uploadFile(files[i], function (response) {
            f.index = self.message.message.attachments.length
            var sendAsLink = false
            if ((f.type).startsWith('video')) {
              sendAsLink = true
            }
            // all attachments must be a link
            sendAsLink = true
            attachment.s3Key = response.data.Key
            attachment.sendAsLink = sendAsLink
            attachment.__finished = true
            self.$broadcast('refresh')
            self.uploading = false
          }, function (err) {
            // attachment.__finished = true
            var index = self.message.message.attachments.indexOf(attachment)
            self.message.attachments.splice(index, 1)
            self.$broadcast('refresh')
            self.$dispatch('show-error', err.data)
            self.uploading = false
          })
        })
      },
      clearFileInput: function () {
        this.$els.file.value = ''
      },
      getLabel: function (key) {
        return label(key)
      },
      getDelayMessagePeriod: function () {
        return this.message['delayMessagePeriod'] ? this.message['delayMessagePeriod'].toString() : '1'
      },
      getAppConfig: function (key) {
        return appConfig(key)
      },
      backToReg: function () {
        this.$dispatch('back-to-reg')
      },
      addAttachment: function () {
        var self = this
        if (!self.uploading) {
          self.clearFileInput()
          self.$els.file.click()
        }
      },
      toggleEye1: function () {
        this.showEmail1 = !this.showEmail1
        this.faEye1.inputType = (this.showEmail1 ? 'email' : 'password')
        this.faEye1.class = {'fa-eye': !this.showEmail1, 'fa-eye-slash': this.showEmail1}
      },
      toggleEye2: function () {
        this.showEmail2 = !this.showEmail2
        this.faEye2.inputType = (this.showEmail2 ? 'email' : 'password')
        this.faEye2.class = {'fa-eye': !this.showEmail2, 'fa-eye-slash': this.showEmail2}
      }
    },
    data: function () {
      return {
        message: {
          message: {
            recipients: '',
            subject: '',
            messageBody: '',
            attachments: []
          },
          initialDelayMessageDate: '',
          delayMessagePeriod: '',
          sendMessageAfter: '',
          delayMethod: '',
          additionalDelayEmail: '',
          serviceCode: 'DELAYED',
          phoneCode: '',
          phoneNumber: '',
          phone: ''
        },
        user: {},
        uploading: false,
        showEmail1: false,
        faEye1: {
          'inputType': 'password',
          'class': {
            'fa-eye': !this.showEmail1,
            'fa-eye-slash': this.showEmail1
          }
        },
        showEmail2: false,
        faEye2: {
          'inputType': 'password',
          'class': {
            'fa-eye': !this.showEmail2,
            'fa-eye-slash': this.showEmail2
          }
        }
      }
    },
    watch: {
      'model': {
        handler: function (model) {
          this.message = this.model
//          this.$broadcast('body-changed', model.messageBody)
          this.$nextTick(function () {
            document.querySelectorAll('.dirty-check').forEach(function (el) {
              var input = el.querySelector('input') || el.querySelector('textarea')
              if (input && input.value) {
                el.MaterialTextfield.checkDirty()
              }
            })
          })
        },
        deep: true
      },
      'uploading': function (newVal, oldlVal) {
        var self = this
        var button = self.$els.savebutton
        if (newVal) {
          button.classList.add('gray')
        } else {
          button.classList.remove('gray')
        }
      }
    },
    events: {
      'remove-file': function (f) {
        var self = this
        file.remove(f.s3Key, function (response) {
        }, function (err) {
          self.$dispatch('show-error', err)
        })
      }
    },
    computed: {
      // totalAttachmentSize: function () {
      //   var result = 0
      //   this.message.message.attachments.forEach(function (attachment) {
      //     result += attachment.size
      //   })
      //   return result
      // },
      defaultTimeZone: function () {
        if (self.user) {
          return this.user.timeZone
        } else {
          var moment = require('moment-timezone')
          return moment.tz.guess()
        }
      },
      limit: function () {
        var moment = require('moment-timezone')
        var from = moment().subtract(1, 'days')
        return [{
          type: 'fromto',
          from: from
        }]
      },
      showEye1: function () {
        // this.inputType = this.showEye1.inputType || this.inputType
        this.isFaEye = this.showEye1.class.isFaEye || this.isFaEye
        this.isFaEyeSlash = this.showEye1.class.isFaEyeSlash || this.isFaEyeSlash
        this.toggleShowEmail()
        this.showEye1.inputType = this.inputType
        this.showEye1.class.isFaEye = this.isFaEye
        this.showEye1.class.isFaEyeSlash = this.isFaEyeSlash
      },
      showEye2: function () {
      }
    }
  }
</script>

<style scoped>
  .padding-top {
    padding-top: 20px;
  }
  .gray {
    background-color: rgba(190,190,190,.2) !important;
    color: black;
  }
</style>



// WEBPACK FOOTER //
// DelayedMessageForm.vue?61013c8e